module.exports = __webpack_public_path__ + "img/gzh.18405aee.png";